<div *ngIf="attachments?.length || showEmpty" class="attachments-list-container">
  <div class="attachment-item-container" *ngFor="let item of attachments">
    <app-attachment-item
      (deleteEvent)="removeAttachment.emit(item)"
      [labelCss]="'flex-1 body-small'"
      [attachmentItem]="item"
      [lockFields]="lockFields"
    ></app-attachment-item>
  </div>
</div>
